<!-- Edit Bid Modal -->
<div class="modal fade" id="kt_modal_update_bid" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header" id="kt_modal_update_bid_header">
        <h2 class="fw-bold">Edit Bid</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal" aria-label="Close">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <!-- Modal Body -->
      <div class="modal-body px-5 my-7">
        <!-- Disabled Form Notice -->
        <div *ngIf="isFormDisabled" class="alert alert-warning d-flex align-items-center mb-7">
          <i class="ki-duotone ki-information-5 fs-2 text-warning me-3">
            <span class="path1"></span>
            <span class="path2"></span>
            <span class="path3"></span>
          </i>
          <div class="d-flex flex-column">
            <span class="fw-bold">Form is disabled</span>
            <span class="fs-7">This bid is not in pending status and cannot be edited.</span>
          </div>
        </div>

        <form [formGroup]="bidForm" (ngSubmit)="onSubmit()" id="kt_modal_update_bid_form">

          <!-- Auction Hall -->
          <div class="fv-row mb-7">
            <label class="required fw-semibold fs-6 mb-2">Auction Hall</label>
            <input
              type="text"
              class="form-control form-control-solid mb-3 mb-lg-0"
              [class.is-invalid]="auctionHall?.invalid && auctionHall?.touched"
              formControlName="auction_hall"
              placeholder="Enter auction hall"
              readonly>
            <div *ngIf="auctionHall?.invalid && auctionHall?.touched" class="invalid-feedback">
              <div *ngIf="auctionHall?.errors?.['required']">Auction Hall is required</div>
            </div>
          </div>

          <!-- Lot No -->
          <div class="fv-row mb-7">
            <label class="required fw-semibold fs-6 mb-2">Lot No</label>
            <input
              type="text"
              class="form-control form-control-solid mb-3 mb-lg-0"
              [class.is-invalid]="lotNo?.invalid && lotNo?.touched"
              formControlName="lot_no"
              placeholder="Enter lot number"
              readonly>
            <div *ngIf="lotNo?.invalid && lotNo?.touched" class="invalid-feedback">
              <div *ngIf="lotNo?.errors?.['required']">Lot No is required</div>
            </div>
          </div>

          <!-- Destination Country -->
          <div class="fv-row mb-7">
            <label class="fw-semibold fs-6 mb-2">Destination Country</label>
            <input
              type="text"
              class="form-control form-control-solid"
              formControlName="destination_country"
              placeholder="N/A"
              readonly>
          </div>

          <!-- Destination Port -->
          <div class="fv-row mb-7">
            <label class="fw-semibold fs-6 mb-2">Destination Port</label>
            <input
              type="text"
              class="form-control form-control-solid"
              formControlName="destination_port"
              placeholder="N/A"
              readonly>
          </div>

          <!-- Bid Offer Price -->
          <div class="fv-row mb-7">
            <label class="required fw-semibold fs-6 mb-2">Bid Offer Price</label>
            <div class="input-group">
              <input
                type="number"
                class="form-control form-control-solid"
                [class.is-invalid]="bidOfferPrice?.invalid && bidOfferPrice?.touched"
                formControlName="bid_offer_price"
                placeholder="0"
                min="0"
                step="1"
                readonly>
              <span class="input-group-text">JPY</span>
            </div>
            <div *ngIf="bidOfferPrice?.invalid && bidOfferPrice?.touched" class="invalid-feedback">
              <div *ngIf="bidOfferPrice?.errors?.['required']">Bid Offer Price is required</div>
            </div>
          </div>

          <!-- Price Type -->
          <div class="fv-row mb-7">
            <label class="fw-semibold fs-6 mb-2">Price Type</label>
            <input
              type="text"
              class="form-control form-control-solid"
              formControlName="price_type"
              placeholder="N/A"
              readonly>
          </div>

          <!-- Price Type Amount -->
          <div class="fv-row mb-7">
            <label class="fw-semibold fs-6 mb-2">Price Type Amount</label>
            <div class="input-group">
              <input
                type="number"
                class="form-control form-control-solid"
                formControlName="price_type_amount"
                placeholder="0"
                min="0"
                step="1"
                readonly>
              <span class="input-group-text">JPY</span>
            </div>
          </div>

          <!-- Bid Status -->
          <div class="fv-row mb-7">
            <label class="required fw-semibold fs-6 mb-2">Bid Status</label>
            <select
              class="form-select form-select-solid"
              [class.is-invalid]="bidStatus?.invalid && bidStatus?.touched"
              formControlName="bid_status">
              <option value="">Select status</option>
              <option *ngFor="let status of bidStatusOptions" [value]="status.value">
                {{ status.label }}
              </option>
            </select>
            <div *ngIf="bidStatus?.invalid && bidStatus?.touched" class="invalid-feedback">
              <div *ngIf="bidStatus?.errors?.['required']">Bid Status is required</div>
            </div>
          </div>

          <!-- Bid Finish Price -->
          <div class="fv-row mb-7">
            <label class="required fw-semibold fs-6 mb-2">Bid Finish Price</label>
            <div class="input-group">
              <input
                type="number"
                class="form-control form-control-solid"
                [class.is-invalid]="bidFinishPrice?.invalid && bidFinishPrice?.touched"
                formControlName="bid_finish_price"
                placeholder="0"
                min="0"
                step="1">
              <span class="input-group-text">JPY</span>
            </div>
            <div *ngIf="bidFinishPrice?.invalid && bidFinishPrice?.touched" class="invalid-feedback">
              <div *ngIf="bidFinishPrice?.errors?.['required']">Bid Finish Price is required</div>
              <div *ngIf="bidFinishPrice?.errors?.['min']">Price must be greater than or equal to 0</div>
            </div>
          </div>

          <!-- Group -->
          <div class="fv-row mb-7">
            <label class="fw-semibold fs-6 mb-2">Group</label>
            <input
              type="text"
              class="form-control form-control-solid"
              formControlName="group"
              placeholder="N/A"
              readonly>
          </div>

          <!-- Unit -->
          <div class="fv-row mb-7">
            <label class="fw-semibold fs-6 mb-2">Units</label>
            <input
              type="text"
              class="form-control form-control-solid"
              formControlName="unit"
              placeholder="N/A"
              readonly>
          </div>

          <!-- Admin Comment -->
          <div class="fv-row mb-7">
            <label class="fw-semibold fs-6 mb-2">Admin Comment</label>
            <textarea
              class="form-control form-control-solid"
              [class.is-invalid]="adminComment?.invalid && adminComment?.touched"
              formControlName="admin_comment"
              rows="4"
              placeholder="Enter admin comment (max 500 characters)"></textarea>
            <div class="form-text">{{ adminComment?.value?.length || 0 }}/500 characters</div>
            <div *ngIf="adminComment?.invalid && adminComment?.touched" class="invalid-feedback">
              <div *ngIf="adminComment?.errors?.['maxlength']">Admin Comment cannot exceed 500 characters</div>
            </div>
          </div>

        </form>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer flex-center">
        <button type="button" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</button>
        <button
          type="submit"
          class="btn btn-primary indicator"
          style="min-width: 120px; height: 44px;"
          [disabled]="isLoading || isFormDisabled"
          (click)="onSubmit()">
          <!--begin::Indicator label-->
          <span class="indicator-label" *ngIf="!isLoading">{{ isFormDisabled ? 'Disabled' : 'Update' }}</span>
          <!--end::Indicator label-->
          <!--begin::Indicator progress-->
          <span class="indicator-progress" *ngIf="isLoading">
            <span class="spinner-border spinner-border-sm align-middle me-2"></span>
            Please wait...
          </span>
          <!--end::Indicator progress-->
        </button>
      </div>
    </div>
  </div>
</div>
